import { type FC, useCallback } from 'react'

import { PageSizeSelector, PaginationInfo } from '@/components/pagination/pagination'
import { PaginationControls } from '@/components/pagination/pagination'
import { Skeleton } from '@/components/skeleton/skeleton'

import { cn } from '@/lib/utils'

interface Props {
  totalCount?: number
  totalPages?: number
  currentPage?: number
  pageSize: number
  disabled?: boolean
  onChange: (page: number, pageSize: number) => void
}

export const ApplicantsPagination: FC<Props> = ({
  totalCount,
  // totalPages,
  currentPage,
  pageSize,
  disabled = false,
  onChange,
}) => {
  const handlePageChange = useCallback(
    (value: number) => {
      onChange(value, pageSize)
    },
    [onChange, pageSize]
  )

  const handlePageSizeChange = useCallback(
    (value: number) => {
      onChange(1, value)
    },
    [onChange]
  )

  const totalPages_ = Math.ceil((totalCount ?? 0) / pageSize)

  return (
    <div className={cn('flex items-center justify-end gap-8')}>
      <PageSizeSelector disabled={disabled} value={pageSize} onChange={handlePageSizeChange} />

      {!currentPage || !totalPages_ ? (
        <Skeleton className="h-4 w-20" />
      ) : (
        <PaginationInfo currentPage={currentPage} totalPages={totalPages_} />
      )}

      <PaginationControls
        currentPage={currentPage ?? 1}
        totalPages={totalPages_}
        disabled={disabled}
        onChange={handlePageChange}
      />
    </div>
  )
}
